import {Chart} from 'angular-highcharts';
import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AdaptedDecimalPipe} from '@rsp/shared/pipes/adapted-decimal.pipe';
import * as Highcharts from 'highcharts';


export interface ChartSeries {
  name: string;
  data: number[];
  color?: string;
  events?: any;

}

export interface ChartParameter {
  year: number;
  month: number;
}

export interface ChartEvent {
  type: string;
  action: any;
}

@Component({
  selector: 'rsp-base-chart',
  templateUrl: './base-chart.component.html',
})
export class BaseChartComponent<T> implements OnInit, AfterViewInit {

  public static adaptedDecimal: AdaptedDecimalPipe = new AdaptedDecimalPipe();

  @Output() chartEvent: EventEmitter<ChartEvent> = new EventEmitter<ChartEvent>();

  public get data(): T {
    return this._data;
  }

  constructor() {


  }

  @Input()
  public set hasError(hasError: boolean) {
    if (this.hasGraph() && hasError) {
      this.onError();
    }
  }

  @Input()
  public set hasNoData(hasNoData: boolean) {
    if (this.hasGraph() && hasNoData) {
      this.onNoData();
    }
  }

  public chart: Chart;
  @Input() public color1: string;
  @Input() public color2: string;
  @Input() public color3: string;
  @Input() public color4: string;
  @Input() public color5: string;
  protected _data: T;

  protected _enableExport: boolean;

  @Input() set enableExport(val: boolean) {
    this._enableExport = val;
  }

  @Input()
  public set data(dto: T) {
    this._data = dto;
    if (dto) {
      this.updateData(dto);
    }
  }

  public static pointFormatter(p: any, unit: string) {
    return `<span style="color:${p.color}">\u25CF</span>
                ${p.series.name}:
                <b>${BaseChartComponent.adaptedDecimal.transform(p.y)} ${unit}</b>
                <br>`;
  }

  ngOnInit(): void {
    this.chart = new Chart(this.createChartOptions());
  }


  public ngAfterViewInit(): void {
    this.updateGraph();
  }

  protected updateData(dto: T): void {
    this._data = dto;
    this.updateGraph();
  }

  /**
   * Will only be called, when Error occured and chart is rendered
   */
  protected onError(): void {
    this.clearData();
  }

  /**
   * Will only be called, when there is no data and chart is rendered
   */
  protected onNoData(): void {
    this.clearData();
  }

  public updateGraph() { // TODO make protected, tests forced it to be public
    if (this.hasGraph() && this.hasData()) {
      this.render();
    }
  }

  protected hasGraph(): boolean {
    return !!this.chart && !!this.chart.ref;
  }

  protected hasData(): boolean {
    return !!this._data;
  }

  public render() {
    this.chart.ref.update({
      exporting: {
        enabled: this._enableExport
      }
    }, false, false, false);
  }

  protected createChartOptions(): Highcharts.Options {
    return {};
  }

  protected clear() {
    while (this.chart.ref && !!this.chart.ref.series && this.chart.ref.series.length) {
      this.chart.removeSeries(0);
    }
  }

  protected clearData() {
    this.chart.ref.series.forEach((series) => {
      series.setData([]);
    });
  }

  public reflow() {
    this.chart.ref.reflow();
  }
}
